import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.tertiary.ButtonTertiaryBackgroundDefault,
    borderWidth: 1,
    borderColor: Buttons.tertiary.ButtonTertiaryStrokeDefault,
  },
  buttonInner: {},
  buttonHover: {
    backgroundColor: Buttons.tertiary.ButtonTertiaryBackgroundHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.tertiary.ButtonTertiaryBackgroundPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.tertiary.ButtonTertiaryBackgroundDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.tertiary.ButtonTertiaryBackgroundDefault,
    borderColor: Buttons.tertiary.ButtonTertiaryStrokeDisable,
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 20,
    textAlign: 'center',
    color: Buttons.tertiary.ButtonTertiaryTextDefault,
  },
  textHover: { color: Buttons.tertiary.ButtonTertiaryTextDefault },
  textPressed: { color: Buttons.tertiary.ButtonTertiaryTextDefault },
  textFocus: { color: Buttons.tertiary.ButtonTertiaryTextDefault },
  textDisabled: {
    color: Buttons.tertiary.ButtonTertiaryTextDisable,
  },
  icon: {
    color: Buttons.tertiary.ButtonTertiaryIconDefault,
  },
  iconHover: {
    color: Buttons.tertiary.ButtonTertiaryIconDefault,
  },
  iconPressed: {
    color: Buttons.tertiary.ButtonTertiaryIconDefault,
  },
  iconDisabled: {
    color: Buttons.tertiary.ButtonTertiaryIconDisable,
  },
  iconFocus: {
    color: Buttons.tertiary.ButtonTertiaryIconDefault,
  },
});
